import axios from 'axios';
import WebApp from '@twa-dev/sdk';

const api = axios.create();

api.interceptors.request.use(config => {
  config.headers.initData = WebApp.initData;
  return config;
});

export default api;
